import { GET_BOOKINGMATRIXREPORTS, GET_BOOKINGREPORTS, GET_CUSTOMERSREPORTS, GET_CUSTOMERMATRIXREPORTS, GET_REVENUEREPORTS, GET_REVENUEMATRIXREPORTS, GET_REVENUEREPORTDOWNLOAD, GET_MISREPORTS,GET_MISREPORTSDOWNLOAD} from "resources/actionTypes";

export function getBookingsReport(reportsPayload) {
    return {
      type: GET_BOOKINGREPORTS.GET_BOOKINGREPORTS_REQUESTED,
      payload: reportsPayload,
    };
}

export function getBookingsMatrix(matrixpayload) {
    return {
      type: GET_BOOKINGMATRIXREPORTS.GET_BOOKINGMATRIXREPORTS_REQUESTED,
      payload: matrixpayload,
    };
}

export function getCustomerReport(reportsPayload) {
  return {
    type: GET_CUSTOMERSREPORTS.GET_CUSTOMERSREPORTS_REQUESTED,
    payload: reportsPayload,
  };
}

export function getCustomerMatrix(matrixpayload) {
  return {
    type: GET_CUSTOMERMATRIXREPORTS.GET_CUSTOMERMATRIXREPORTS_REQUESTED,
    payload: matrixpayload,
  };
}

export function getRevenueReport(revenuePayload) {
  return {
    type: GET_REVENUEREPORTS.GET_REVENUEREPORTS_REQUESTED,
    payload: revenuePayload,
  };
}

export function getRevenueMatrix(matrixpayload) {
  return {
    type: GET_REVENUEMATRIXREPORTS.GET_REVENUEMATRIXREPORTS_REQUESTED,
    payload: matrixpayload,
  };
}

// Download Report
export function getRevenueDownLoad(downloadData) {
  return {
    type: GET_REVENUEREPORTDOWNLOAD.GET_REVENUEREPORTDOWNLOAD_REQUESTED,
    payload: downloadData,
  };
}

export function getMisReport(misPayload) {
  return {
    type: GET_MISREPORTS.GET_MISREPORTS_REQUESTED,
    payload: misPayload,
  };
}

export function getMisReportDownload(data) {
  return {
    type: GET_MISREPORTSDOWNLOAD.GET_MISREPORTSDOWNLOAD_REQUESTED,
    payload: data,
  };
}
